export default __webpack_public_path__ + "static/media/4.8346c3d4.png";